import { Button, Card, Container, Divider, Grid, Hidden, makeStyles, Typography } from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import { blueGrey, green, grey, purple } from "@material-ui/core/colors";
import { AccessTime, Android, AndroidOutlined, Apple, AppsOutlined, Done, LockOutlined, Mood, NotificationsActiveOutlined, Reorder } from "@material-ui/icons";
import shieldBackground from "../../constants/images/shield.svg";
import ProgressChart from "./ProgressChart";
import { AuthUserContext, withAuthorization } from "../Session";
import { useTranslation } from "react-i18next";
import ModuleCard from "./ModuleCard";
import { MotionScreen } from "react-motion-layout";
import CourseModule from "../CourseModule";
import Footer from "../Footer";
import { useHistory } from "react-router-dom";
import * as ROUTES from "../../constants/routes";

import Logo from "../../assets/logo.png";

const initialChartData = [
  { x: 1, y: 0 },
  { x: 2, y: 100 },
];

const HomeScreen = (props) => {
  const styles = useStyles();
  const { firebase } = props;
  const { t } = useTranslation();
  const modulesref = useRef();
  const history = useHistory();

  const [percent, setPercent] = useState(0);
  const [data, setdata] = useState(initialChartData);
  const [showSuccess, setShowSuccess] = useState(false);
  const [courses, setcourses] = useState([]);
  const [reports, setReports] = useState({});
  const [moduleView, setModuleView] = useState(-1);
  const [isCompleted, setIsCompleted] = useState(false);
  const [uid, setUid] = useState(firebase.currentUser()?.uid);
  const [moduleProgress, setModuleProgress] = useState([false, false, false]);

  useEffect(() => {
    firebase
      .courses()
      .once("value")
      .then((snap) => {
        let courses = [];
        Object.keys(snap.val()).map((course) => {
          courses[snap.val()[course].circlePos - 1] = {
            ...snap.val()[course],
            id: course,
          };
        });
        setcourses(courses);
      })
      .catch((err) => {
        history.push(ROUTES.ERROR);
      });

    const listenerRef = firebase.userReport(firebase.currentUser()?.uid).on("value", (snap) => {
      let percent = 0;
      const reports = snap.val();
      setReports(reports);
      let moduleProgressAux = [];

      Object.keys(reports.tests).forEach((k) => {
        let meta = reports?.tests[k]?.metadata;
        let currentQuestion = typeof meta?.currentQuestion !== "number" ? 0 : meta?.currentQuestion;
        let totalQuestion = typeof meta?.totalQuestions !== "number" ? 1 : meta?.totalQuestions;
        moduleProgressAux.push(meta?.evalApproved);
        percent = percent + ((meta?.studed ? 50 : 0) + (meta?.evalApproved ? 50 : (currentQuestion / totalQuestion) * 50)) / 3;
        setTimeout(() => {
          setIsCompleted(percent === 100);
        }, 950);
      });
      setModuleProgress(moduleProgressAux);
      setPercent(percent);
      setdata([
        { x: 1, y: percent },
        { x: 2, y: 100 - percent },
      ]);
    });

    return () => firebase.userReport(uid).off("value", listenerRef);
  }, []);

  if (moduleView != -1) {
    return <CourseModule setModuleView={setModuleView} courseInfo={courses[moduleView]} />;
  } else {
    return (
      <AuthUserContext.Consumer>
        {(authUser) => (
          <Grid className={styles.mainContainer}>
            {authUser.sgpfc.justPassed && history.push(ROUTES.ACTIVERESCUER)}
            <Grid container className={styles.headerContainer}>
              <Container>
                <Grid container alignContent="center" justifyContent="center" style={{ paddingBottom: 55 }}>
                  <Grid item xs={12} md={7} lg={8}>
                    <Typography variant="h1" className={styles.mainTitle}>
                      {t("mainPageTitle")}
                    </Typography>
                    <Typography className={styles.mainSubtitle}>{percent !== 100 ? t("mainPageSubtitle") : t("mainPageSubtitleCompleted")}</Typography>

                    <Grid item xs={12} md={5} container style={{ marginTop: 32 }}>
                      <Grid item xs={6}>
                        <img style={{ width: "100%", cursor: "pointer" }} src={Logo} onClick={() => window.open("https://www.bexencardio.com/es/", "_blank").focus()} />
                      </Grid>
                    </Grid>
                    <Grid className={styles.nextSteps} item xs={12} container direction="column">
                      <Typography variant="h6" className={styles.mainSubtitle}>
                        {percent !== 100
                          ? t("completeAllModulesHomeTextButton")
                          : authUser.sgpfc.alertAccess
                          ? t("DownloadReanibexAlertHomeTextButton")
                          : t("Gracias por ser parte de nuestra comunidad. ¡Juntos salvamos más vidas!")}
                      </Typography>

                      <Grid item xs={10}>
                        <Button
                          variant="contained"
                          color="secondary"
                          className={percent === 0 && "pulse"}
                          style={{ textTransform: "none", fontSize: "1.15rem", padding: "10px 24px", marginTop: authUser.sgpfc.alertAccess ? 18 : 32 }}
                          onClick={() => modulesref.current.scrollIntoView({ behavior: "smooth" })}
                        >
                          {percent === 0 ? t("startCourse") : percent === 100 ? t("reviewFormation") : t("continueFormation")}
                        </Button>
                      </Grid>
                      {percent === 100 && authUser.sgpfc.alertAccess && (
                        <Grid item xs={12} md={10}>
                          <Button
                            variant="outlined"
                            color="secondary"
                            className={styles.downloadButton}
                            style={{ marginRight: 12 }}
                            onClick={() => window.open("https://play.google.com/store/apps/details?id=com.reanibex_alert", "_blank").focus()}
                          >
                            <Android style={{ fontSize: 42, marginRight: 9, color: blueGrey[400] }} />
                            {t("downloadreanibexAlert_ANDROID")}
                          </Button>
                          <Button
                            variant="outlined"
                            color="secondary"
                            className={styles.downloadButton}
                            onClick={() => window.open("https://apps.apple.com/es/app/reanibex-alert/id6445820800", "_blank").focus()}
                          >
                            <Apple style={{ fontSize: 38, marginRight: 9, color: blueGrey[400], marginLeft: -9 }} />
                            {t("downloadreanibexAlert_IOS")}
                          </Button>
                        </Grid>
                      )}
                    </Grid>
                  </Grid>

                  <Grid item xs={12} md={5} lg={4} container spacing={2} direction="column" className={styles.CourseDetailContainer}>
                    <Hidden smDown>
                      <Divider orientation="vertical" style={{ marginRight: 16, marginLeft: 16 }} />
                    </Hidden>

                    <Grid item container direction="row" spacing={3}>
                      <Hidden smUp>
                        <Card variant="outlined" className={styles.progressCard}>
                          <Grid item xs={12} container justify="center">
                            <ProgressChart showSuccess={showSuccess} data={data} percent={percent} isCompleted={isCompleted} />
                          </Grid>
                        </Card>
                      </Hidden>
                      <Hidden xsDown>
                        <Grid item xs={12} sm={6} container justify="center">
                          <ProgressChart showSuccess={showSuccess} data={data} percent={percent} isCompleted={isCompleted} />
                        </Grid>
                      </Hidden>

                      <Grid item xs={12} sm={6} container>
                        <Typography variant="h6" className={styles.progressTitle}>
                          {t("courseDetail")}
                        </Typography>
                        <Grid container spacing={2}>
                          <Grid item xs={12} container direction="row" alignItems="center" onClick={() => modulesref.current.scrollIntoView({ behavior: "smooth" })}>
                            <Reorder style={{ color: purple[400] }} />
                            <Typography variant="h6" className={styles.detailItem}>
                              {t("modules_3")}
                            </Typography>
                          </Grid>
                          <Grid item xs={12} className={styles.detailContainer} container direction="row" alignItems="center">
                            <AccessTime style={{ color: purple[400] }} />
                            <Typography variant="h6" className={styles.detailItem}>
                              {t("25minutes")}
                            </Typography>
                          </Grid>
                          <Grid item xs={12} className={styles.detailContainer} container direction="row" alignItems="center">
                            <Mood style={{ color: purple[400] }} />
                            <Typography variant="h6" className={styles.detailItem}>
                              {t("todos_los_publicos")}
                            </Typography>
                          </Grid>
                          {authUser.sgpfc.alertAccess && (
                            <Grid item xs={12} className={styles.detailContainer} container direction="row" alignItems="center">
                              {percent != 100 ? (
                                <NotificationsActiveOutlined style={{ color: purple[400] }} />
                              ) : (
                                <Done style={{ color: green[400], position: "relative", left: 0 }} />
                              )}
                              <Typography variant="h6" className={styles.detailItem}>
                                {t("acceso_alertas")}
                              </Typography>
                            </Grid>
                          )}
                        </Grid>
                      </Grid>

                      <Grid item xs={12} container className={styles.badgeContainer} container direction="row" alignItems="center" spacing={2}>
                        <Grid item xs={12}>
                          <Typography variant="h6" className={styles.badgeTitle}>
                            {t("badge")}
                          </Typography>
                          <Typography variant="body1" className={styles.badgeText}>
                            {t("badgeDescriptiontext", { total: moduleProgress.filter((v) => v).length })}
                          </Typography>
                        </Grid>
                        {moduleProgress.map((v, k) => (
                          <Grid item xs={4} lg={3} container className={styles.detailBadgeContainer}>
                            <div className={styles.detailBadge}>
                              {v ? <img button style={{ maxHeight: `44px` }} src={t(`formation${k + 1}Image`)} /> : <LockOutlined style={{ fontSize: 40, color: grey[500] }} />}
                            </div>
                          </Grid>
                        ))}
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Container>
            </Grid>
            <Grid container className={styles.modulesContainer}>
              <Container>
                <Grid container spacing={3} ref={modulesref}>
                  <Grid item xs={12}>
                    <Typography variant="h2" className={styles.modulesTite}>
                      {t("modules_(3)")}
                    </Typography>
                  </Grid>
                  <MotionScreen>
                    {reports?.tests !== undefined &&
                      courses.map((d, k) => <ModuleCard d={d} key={k} k={k} reports={reports?.tests[`ECS${k + 1}`].metadata} setModuleView={setModuleView} />)}
                  </MotionScreen>
                </Grid>
              </Container>
            </Grid>
            <Footer />
          </Grid>
        )}
      </AuthUserContext.Consumer>
    );
  }
};

const condition = (authUser) => !!authUser;

export default withAuthorization(condition)(HomeScreen);

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    backgroundColor: grey[100],
  },
  progressCard: {
    padding: 24,
    marginTop: 72,
    marginBottom: 24,
    borderRadius: 9,
    [theme.breakpoints.down("sm")]: {
      marginTop: 24,
    },
  },
  mainTitle: {
    letterSpacing: 0,
    color: "#3c4043",
    marginBottom: 8,
    [theme.breakpoints.up("sm")]: {
      font: "400 40px/50px Google Sans,Arial,sans-serif",
      paddingRight: 25,
    },
    [theme.breakpoints.down("sm")]: {
      font: "400 30px/40px Google Sans,Arial,sans-serif",
    },
  },
  modulesTite: {
    letterSpacing: 0,
    color: "#3c4043",
    font: "400 40px/50px Google Sans,Arial,sans-serif",
    [theme.breakpoints.up("sm")]: {
      marginBottom: theme.spacing(3),
      marginTop: theme.spacing(4),
    },
    [theme.breakpoints.down("sm")]: {
      marginBottom: theme.spacing(1),
      marginTop: theme.spacing(2),
    },
  },
  mainSubtitle: {
    animation: "fade-down .8s ease .3s 1 normal both running",
    color: "#9aa0a6",
    font: "400 16px/26px Google Sans,Arial,sans-serif",
    marginRight: 9,
    [theme.breakpoints.up("sm")]: {
      maxWidth: "80%",
    },
  },
  headerContainer: {
    [theme.breakpoints.up("sm")]: {
      marginTop: 20,
      paddingTop: 52,
    },
    [theme.breakpoints.down("sm")]: {
      marginTop: 12,
      paddingTop: 20,
    },

    backgroundColor: "white",
    zIndex: -1,
    boxShadow: "0px 2px 3px -1px rgb(0 0 0 / 20%), 0 0px 0px rgba(0,0,0,0.24)",
  },
  CourseDetailContainer: {
    [theme.breakpoints.only("sm")]: {
      marginTop: 36,
    },
    [theme.breakpoints.only("xs")]: {
      marginTop: 0,
    },
  },
  chartText: {
    fontSize: 64,
  },
  progressTitle: {
    color: "#80868b",
    font: "500 12px/15.6px Google Sans,Arial,sans-serif",
    letterSpacing: "1.3px",
    textTransform: "uppercase",
    paddingBottom: theme.spacing(3.5),
  },
  badgeContainer: {
    //border: "dotted 1px",
    [theme.breakpoints.up("sm")]: {
      marginTop: theme.spacing(4),
    },
  },
  detailContainer: {
    [theme.breakpoints.up("sm")]: {
      marginTop: theme.spacing(1),
    },
    [theme.breakpoints.down("sm")]: {
      marginTop: 8,
    },
  },
  detailItem: {
    marginLeft: theme.spacing(1.5),
    opacity: 0.9,
    color: "#5f6368",
    font: "400 16px/22px Google Sans,Arial,sans-serif",
    letterSpacing: "normal",
  },
  badgeTitle: {
    color: "#80868b",
    font: "500 12px/15.6px Google Sans,Arial,sans-serif",
    letterSpacing: "1.3px",
    textTransform: "uppercase",
    paddingBottom: 16,
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(2),
    },
  },
  badgeText: {
    font: "300 16px/27.2px Roboto,Arial,Helvetica,serif",
    paddingBottom: 16,
  },
  detailBadgeContainer: {
    [theme.breakpoints.down("sm")]: {
      justifyContent: "center",
    },
  },
  detailBadge: {
    alignItems: "center",
    backgroundImage: `url(${shieldBackground})`,
    backgroundPosition: "50%",
    backgroundRepeat: "no-repeat",
    backgroundSize: "100%",
    display: "flex",
    flex: "0 0 75px",
    height: 88,
    justifyContent: "center",
  },
  modulesContainer: {
    padding: "55px 0 60px",
  },
  nextSteps: {
    [theme.breakpoints.up("sm")]: {
      marginTop: 24,
    },
    [theme.breakpoints.down("sm")]: {
      marginTop: 24,
    },
  },

  downloadButton: {
    textTransform: "none",
    fontSize: "1.15rem",
    padding: "10px 24px",
    marginTop: 16,
    height: 72,

    [theme.breakpoints.up("sm")]: {},
    [theme.breakpoints.down("sm")]: {},
  },
}));
